import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import AddEditBillCodeModal from "./AddBillCodeModal";

export default function AddBillCodeForGenerateInvoice(props) {
  const [startAddBillCode, setStartAddBillCode] = useState(false);

  function handleAddBillCode() {
    setStartAddBillCode(!startAddBillCode);
  }

  return (
    <>
      <Modal
        size="md"
        centered
        show={props.show}
        onHide={props.onHide}
        dialogClassName=""
      >
        <ModalHeader className="justify-content-center">
          <div>
            <img src={logo} alt="" height="30" className="ms-4 text-center" />
          </div>
        </ModalHeader>

        <ModalBody>
          <h6 className="text-center">
            Would you like to save{" "}
            <span className="txt-secondary "> {props?.billItem?.name}</span> as
            a bill code for future use?
          </h6>
        </ModalBody>

        <ModalFooter className="justify-content-center">
          <Button
            className="primary"
            onClick={() => {
              handleAddBillCode();
              props.onHide();
            }}
            isLoading={startAddBillCode}
            buttonTitle={startAddBillCode ? "Loading..." : "Yes"}
          />
          <Button
            className="secondary outline"
            type="button"
            onClick={() => {
              props?.handleModalClose(props?.indexOfNewBillItem);
              props.onHide();
            }}
          >
            No
          </Button>
        </ModalFooter>
      </Modal>
      <AddEditBillCodeModal
        show={startAddBillCode}
        onHide={handleAddBillCode}
        isEditModal={false}
        billCode={{ ...props?.billItem }}
        isModalFromGenerateInvoice={true}
        getBillCodeList={props?.getUpdatedList}
        indexOfNewBillItem={props?.indexOfNewBillItem}
      />
    </>
  );
}

